export default "__VITE_ASSET__BpxsnQ4M__"